// import react libraries
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// import common components
import SideBar from "./SideBar";

const Layout = ({children, sendTabCheckDataFromChild}) => {
    const location = useLocation();
    // get last toggle status
    const local = localStorage.getItem('toggle');
    const locale = localStorage.getItem('locale');

    // Check if current path is AI chat - sidebar should be collapsed (closed)
    const isAiChatPath =
        location.pathname.startsWith("/aura-ai-assistant") ||
        location.pathname.startsWith("/customer/aura-ai-assistant");

    // variable - default to collapsed (1) for AI chat path
    const [isToggle, setIsToggle] = useState(() => {
        if (isAiChatPath) return 1;
        return parseInt(local) ? parseInt(local) : 0;
    });

    // Auto-collapse sidebar when navigating to AI chat page
    useEffect(() => {
        if (isAiChatPath) {
            setIsToggle(1);
        }
    }, [isAiChatPath]);

    const handleToggleFromChild = (data) => {
        setIsToggle(data);
    };
    const handleTabChangeDataFromChild = (data) => {
        sendTabCheckDataFromChild(data);
    };

    return (
        <div className="relative">
            <div className="">
                <SideBar setToggleFromChild={handleToggleFromChild} sendTabChangeDataFromChild={handleTabChangeDataFromChild} />
            </div>
            <div className={(isToggle ? 'sm:ml-16' : (locale === 'gr' ? 'md:ml-60' : 'md:ml-56')) + " bg-background-normal1 h-full min-h-screen"}>
                <div
                    className={
                        (isToggle ? "mt-16" : "") +
                        " sm:mt-0 " +
                        (isAiChatPath
                            ? "p-0"
                            : "p-2 sm:p-4 space-y-2 sm:space-y-4")
                    }
                >
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout;
